function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCancelTime = function SvgCancelTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 24349"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 20092",
    style: {
      fill: "transparent"
    },
    d: "M0 0h18v18H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17779",
    d: "M9 6.333V9l2 2m4-2a6 6 0 1 1-6-6 6 6 0 0 1 6 6Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17920",
    d: "M1.992 0A1.863 1.863 0 0 1 3.95 1.762l-.029 15.887a1.878 1.878 0 0 1-1.964 1.768A1.863 1.863 0 0 1 0 17.654L.028 1.768A1.878 1.878 0 0 1 1.992 0Z",
    transform: "rotate(135 5.634 10.809)",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17921",
    d: "M.911 0a.875.875 0 0 1 .878.878l-.03 15.83a.879.879 0 1 1-1.759 0L.03.881A.883.883 0 0 1 .911 0Z",
    transform: "rotate(135 4.904 10.575)",
    style: {
      fill: "currentColor"
    }
  })));
};

export default SvgCancelTime;